import { jsx } from 'react/jsx-runtime';
import { memo, forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import { BadgeSizeXL } from '../sizes/index.js';
import { useStyles } from '../styles/index.js';
import { BadgeIcons, BadgeTypes } from '../types/index.js';
import { BadgeSkins } from '../skins/index.js';
import { computeResponsiveness } from '../../../../foundation/responsive/helpers/index.js';

const Badge = memo(forwardRef(({ variant = BadgeTypes.Premium, size = BadgeSizeXL, className, dataTestId, hasShadow = true, ...props }, ref) => {
    const skin = BadgeSkins[variant];
    const sizes = useMemo(() => computeResponsiveness(size), [size]);
    const styles = useStyles({ skin, sizes, hasShadow });
    const Icon = useMemo(() => BadgeIcons[variant], [variant]);
    return (jsx("i", { ...props, className: clsx(styles.root, className), "data-testid": dataTestId || 'badge', ref: ref, children: jsx(Icon, { className: styles.icon }) }));
}));
Badge.displayName = 'Badge';

export { Badge };
